export default (text, count, replaceWith) => {
  const regex = new RegExp(`^.{${count}}`);
  return text?.replace(regex, replaceWith);
};
